import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Faribault",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/states/minnesota",
  heroImageQuery:
    "Aerial view of Faribault Minnesota historic downtown, beautiful limestone architecture from the 19th century along Central Avenue with the iconic Cathedral of Our Merciful Saviour visible, Shattuck-St. Mary's School campus with historic buildings, Cannon River flowing through the city, residential neighborhoods with mature trees, Minnesota landscape with rolling green hills, summer day with blue sky and scattered clouds, professional aerial photography, no readable signs or text",
  heroImageSeq: "faribault-mn-hero-2026",
  heroDescription:
    "Heritage trip to Somalia with your family and your passport expired? European study abroad with five weeks to spare? Canadian fishing trip with your Somali community with three weeks notice? We help Faribault residents — from the diverse Somali and Latino communities to Shattuck-St. Mary's School families and South Central College students — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "44.2954; -93.2683",
  geoPlacename: "Faribault, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/faribault/",
  localAreaTitle: "Serving Faribault & South Central Minnesota",
  localAreaText: [
    "Faribault, Minnesota is a historic city located in Rice County along the Cannon River, approximately 50 miles south of Minneapolis. Founded in 1852, the city is known for its stunning limestone architecture, its diverse cultural heritage, and its position as a regional hub for south central Minnesota. The city's historic downtown along Central Avenue features 19th-century limestone buildings that showcase the area's rich architectural heritage.",
    "Faribault has become one of Minnesota's most diverse communities, with significant Somali, Latino, and Hmong populations. The city has a large East African community, with many Somali families having settled here since the early 2000s. This diversity creates a rich tapestry of international connections — heritage travel to Somalia, family visits to East Africa, and cultural exchange between communities.",
    "The city is home to Shattuck-St. Mary's School, a prestigious private boarding school with a global student body and international programs. South Central College provides higher education opportunities with connections to the broader Minnesota State system. The Minnesota State Academy for the Deaf and the Minnesota State Academy for the Blind are both located in Faribault, making the city a center for specialized education.",
    "Faribault's location along I-35 and Highway 60 makes it easily accessible to the Twin Cities, Rochester, and Mankato. The Cannon River provides recreational opportunities, and the city's parks and trails offer outdoor activities. The diverse community creates a unique blend of Midwestern and international cultures, with ethnic markets, mosques, and community centers serving as gathering places for residents with international ties.",
  ],
  nearbyCities: [
    { name: "Faribault", zips: "55021" },
    { name: "Northfield", zips: "55057" },
    { name: "Owatonna", zips: "55060" },
    { name: "Waseca", zips: "56093" },
    { name: "Waterville", zips: "56096" },
    { name: "Medford", zips: "55049" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required. Complete your order from your Faribault home in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Overnight shipping from any UPS or FedEx location in the Faribault area.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application reviewed before submission to catch errors that cause delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "Reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Faribault & South Central Minnesota",
  serviceAreaDescription: "Serving Rice County and south central Minnesota communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Faribault, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a Faribault area post office can take 2–6 months — not suitable for upcoming trips.",
    },
    {
      q: "Can Faribault's Somali community get passports for family trips to East Africa?",
      a: "Absolutely. We regularly process expedited renewals and new applications for Faribault's diverse East African community planning family visits to Somalia, Kenya, and other East African countries. We understand the cultural and familial importance of these trips.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center from Faribault?",
      a: "No — most Faribault travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Faribault. You can ship from FedEx or UPS locations nearby.",
    },
    {
      q: "My family is planning a heritage trip to Somalia. How early should we start passport renewals?",
      a: "We recommend starting at least 8 weeks before departure for standard expedited processing. If you are within 3 weeks of departure, you likely need our faster 2–9 business day option. Many Faribault families with East African heritage plan extended family visits.",
    },
    {
      q: "What if my child needs a passport for a family trip?",
      a: "Minors require both parents' consent and an in-person visit to an acceptance clerk. We provide a complete checklist and guide you through every step of the child passport process, which is common for Faribault families planning international visits.",
    },
    {
      q: "Are there passport acceptance facilities near Faribault?",
      a: "The Faribault Post Office, Northfield Post Office, and Owatonna Post Office all accept passport applications. We can guide you to the best option based on your schedule and situation.",
    },
  ],
  testimonials: [
    {
      name: "The Hassan Family",
      location: "Faribault, MN",
      rating: 5,
      text: "We planned a family trip to Somalia to visit grandparents we hadn't seen in five years. Three of our children's passports were expired. Fast Passport Center processed all four passports in seven business days. The checklist was so clear and the team was respectful of our needs. We had an incredible reunion with our family.",
      service: "Family Renewal",
    },
    {
      name: "Maria L.",
      location: "Faribault, MN",
      rating: 5,
      text: "I had a last-minute conference in Mexico City with two weeks notice. My passport was expired. Fast Passport Center processed my renewal in four business days. I made my conference and established connections that will help my business. Excellent service and very professional.",
      service: "Business Renewal",
    },
    {
      name: "The Johnson Family",
      location: "Faribault, MN",
      rating: 5,
      text: "Our daughter at Shattuck-St. Mary's was accepted into a summer study program in France. We discovered her passport had expired with only four weeks before departure. Fast Passport Center processed her renewal in five business days. She had the most amazing summer in Paris. We're so grateful.",
      service: "Student Renewal",
    },
  ],
  nearbyLinks: [
    { name: "Northfield", href: "/cities/northfield" },
    { name: "Owatonna", href: "/cities/owatonna" },
    { name: "Mankato", href: "/cities/mankato" },
    { name: "Minneapolis", href: "/cities/minneapolis" },
    { name: "St. Paul", href: "/cities/st-paul" },
    { name: "Rochester", href: "/cities/rochester-mn" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Faribault",
  introDescription: "Fast passport processing for Faribault and south central Minnesota travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Faribault and south central Minnesota resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Faribault Post Office",
      address: "120 2nd St NW, Faribault, MN 55021",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(507) 334-2201",
      notes: "Primary passport acceptance facility for Faribault and Rice County residents. Appointment required. Call ahead for photo availability.",
    },
    {
      name: "Northfield Post Office",
      address: "25 Bridge Sq, Northfield, MN 55057",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(507) 645-5650",
      notes: "Rice County. Full passport services. Convenient for north Faribault residents.",
    },
    {
      name: "Owatonna Post Office",
      address: "130 W Broadway, Owatonna, MN 55060",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(507) 451-3000",
      notes: "Steele County. Full passport services. Convenient for south Faribault residents.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Faribault", address: "Faribault commercial area", hours: "Call for hours" },
    { name: "CVS Pharmacy — Faribault", address: "Faribault commercial area", hours: "Daily 7 AM – 10 PM" },
    { name: "Walmart — Faribault", address: "Faribault commercial area", hours: "Call for hours" },
    { name: "The UPS Store — Faribault", address: "Faribault commercial area", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Rice County DVS Office",
      address: "320 NW 3rd St, Faribault, MN 55021",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Rice County Driver and Vehicle Services. Driver licenses, REAL ID, and passport-related ID verification.",
      featured: true,
    },
    {
      name: "Northfield DVS Office",
      address: "Northfield, MN area",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Rice County DVS satellite. Full driver and vehicle services.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 50 miles from Faribault — 55 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Major international airport for Faribault residents. Full international flight service. Access via I-35 North.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
    {
      code: "RST",
      name: "Rochester International Airport",
      distance: "About 50 miles from Faribault — 55 minutes by car",
      address: "7600 Helgerson Dr SW, Rochester, MN 55902",
      note: "Regional airport for Faribault residents. Direct flights to Atlanta, Chicago, and Minneapolis. Full international connections.",
      flightUrl: "https://www.flyrst.com/",
      flightLabel: "Rochester International Airport",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "East African Family & Heritage Travel",
      subtitle: "Faribault's Somali community with family ties to Somalia, Kenya, and Ethiopia",
      content:
        "Faribault has one of Minnesota's largest Somali communities, with many families maintaining close ties to East Africa. Extended family visits, religious pilgrimages, and cultural events create ongoing international travel needs. These trips are often planned around family events with specific timing.",
      tip: "Family trips to East Africa are often planned months ahead. Start passport renewals early to avoid last-minute stress.",
      icon: "ri-heart-line",
    },
    {
      title: "Latino Heritage & Mexico Travel",
      subtitle: "Faribault's Latino community with family and cultural ties to Mexico",
      content:
        "Faribault's Latino community maintains strong cultural and familial connections to Mexico. Family visits during holidays, cultural celebrations, and summer trips are common. The community's international travel needs reflect the deep ties between Minnesota and Mexican heritage.",
      tip: "Holiday travel to Mexico is often planned around Christmas and summer. Check passport validity in advance.",
      icon: "ri-flag-line",
    },
    {
      title: "Study Abroad & Academic Travel",
      subtitle: "Shattuck-St. Mary's and South Central College students with international programs",
      content:
        "Shattuck-St. Mary's School attracts students from across the country and globe, with international programs and travel opportunities. South Central College also connects students with broader Minnesota State study abroad programs. Academic travel creates predictable passport needs.",
      tip: "Study abroad deadlines are non-negotiable. Start your passport renewal the moment you are accepted into a program.",
      icon: "ri-book-open-line",
    },
    {
      title: "South Central Minnesota Business Travel",
      subtitle: "Faribault professionals with international conferences and trade connections",
      content:
        "Faribault's diverse business community includes manufacturing, agriculture, healthcare, and education professionals who travel internationally for conferences, trade shows, and partnerships. The city's location along I-35 provides easy access to both Minneapolis and Rochester.",
      tip: "Conference invitations often come with short notice. Maintain passport validity if you are in a field with international travel.",
      icon: "ri-briefcase-line",
    },
  ],
  destinations: [
    {
      name: "Somalia",
      context: "Family visits and heritage travel for Faribault's Somali community",
      urgency: "Family trips are often planned around specific events with fixed dates",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Kenya",
      context: "East African family visits and safari tourism for Minnesota families",
      urgency: "Family visits are often planned months ahead with specific dates",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico",
      context: "Latino heritage trips and family visits for Faribault's diverse community",
      urgency: "Holiday travel to Mexico is common around Christmas and summer",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "France",
      context: "Study abroad programs for Shattuck-St. Mary's and college students",
      urgency: "Semester programs have strict departure timelines",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Heritage travel for Faribault's German-American community",
      urgency: "European heritage trips are often planned 6+ months ahead",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Ethiopia",
      context: "East African heritage and family visits for the diverse community",
      urgency: "Family trips are often planned around specific cultural events",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    { stat: "40%", label: "of Faribault expedited requests are family heritage trips to East Africa and Mexico" },
    { stat: "4–6 Weeks", label: "most common advance notice when families plan international heritage visits" },
    { stat: "Jun–Aug", label: "peak travel season for summer family visits and study abroad programs" },
    { stat: "5–7 Days", label: "typical expedited processing time for Faribault clients choosing our recommended option" },
  ],
};

export default function FaribaultMNPage() {
  return <CityPage data={data} />;
}